/**
 * Comprehensive Phrases Data - Modal Verbs & Quantity
 * 情态动词和数量短语集合
 *
 * 包含情态动词表达和数量描述，约35个短语
 */

import { Phrase } from './phrases-types';

export const modalQuantityPhrases: Phrase[] = [
  // ==================== 情态动词短语 Modal Verb Phrases ====================

  // Can - 能力、许可
  {
    id: 'modal_can',
    phrase: 'can do',
    phonetic: '/kæn duː/',
    meaning: '能做……',
    usageScenario: '描述有能力做某事或被允许做某事',
    example: 'I can swim.',
    exampleTranslation: '我会游泳。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'modal_can_not',
    phrase: 'cannot do',
    phonetic: '/ˈkænɒt duː/',
    meaning: '不能做……',
    usageScenario: '描述没有能力做某事或不被允许做某事',
    example: 'I cannot fly.',
    exampleTranslation: '我不会飞。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'modal_can_not_short',
    phrase: "can't do",
    phonetic: '/kænt duː/',
    meaning: '不能做……',
    usageScenario: 'cannot的缩写形式，更口语化',
    example: "I can't speak French.",
    exampleTranslation: '我不会说法语。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'modal_can_see',
    phrase: 'can see',
    phonetic: '/kæn siː/',
    meaning: '能看见',
    usageScenario: '描述能够看见某物',
    example: 'I can see a bird in the tree.',
    exampleTranslation: '我能看见树上有一只鸟。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'modal_can_hear',
    phrase: 'can hear',
    phonetic: '/kæn hɪr/',
    meaning: '能听见',
    usageScenario: '描述能够听见声音',
    example: 'I can hear the music.',
    exampleTranslation: '我能听见音乐。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },

  // Must - 必须、义务
  {
    id: 'modal_must',
    phrase: 'must do',
    phonetic: '/mʌst duː/',
    meaning: '必须做……',
    usageScenario: '描述必须做某事，强调义务或必要性',
    example: 'You must study hard.',
    exampleTranslation: '你必须努力学习。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'modal_must_not',
    phrase: 'must not do',
    phonetic: '/mʌst nɒt duː/',
    meaning: '禁止做……',
    usageScenario: '描述禁止做某事，强调不应该做',
    example: 'You must not play with fire.',
    exampleTranslation: '你不准玩火。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'modal_mustnt',
    phrase: "mustn't do",
    phonetic: '/ˈmʌsnt duː/',
    meaning: '禁止做……',
    usageScenario: 'must not的缩写形式，更口语化',
    example: "You mustn't run in the classroom.",
    exampleTranslation: '你不准在教室里跑。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },

  // Should - 应该、建议
  {
    id: 'modal_should',
    phrase: 'should do',
    phonetic: '/ʃʊd duː/',
    meaning: '应该做……',
    usageScenario: '描述应该做某事，给出建议或意见',
    example: 'You should help your parents.',
    exampleTranslation: '你应该帮助你的父母。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'modal_should_not',
    phrase: 'should not do',
    phonetic: '/ʃʊd nɒt duː/',
    meaning: '不应该做……',
    usageScenario: '描述不应该做某事，给出否定的建议',
    example: 'You should not eat too much candy.',
    exampleTranslation: '你不应该吃太多糖果。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'modal_shouldnt',
    phrase: "shouldn't do",
    phonetic: '/ˈʃʊdnt duː/',
    meaning: '不应该做……',
    usageScenario: 'should not的缩写形式，更口语化',
    example: "You shouldn't be late for school.",
    exampleTranslation: '你不应该上学迟到。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },

  // May - 可能、许可
  {
    id: 'modal_may',
    phrase: 'may do',
    phonetic: '/meɪ duː/',
    meaning: '可以做……/ 可能做……',
    usageScenario: '描述可能发生某事或礼貌地请求许可',
    example: 'It may rain tomorrow.',
    exampleTranslation: '明天可能会下雨。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'modal_may_not',
    phrase: 'may not',
    phonetic: '/meɪ nɒt/',
    meaning: '可能不……',
    usageScenario: '描述可能不发生某事',
    example: 'He may not come today.',
    exampleTranslation: '他今天可能不来。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    frequency: 'low'
  },

  // ==================== 数量和数量短语 Quantity Phrases ====================

  // 数量描述（可数）
  {
    id: 'quant_many',
    phrase: 'many...',
    phonetic: '/ˈmeni/',
    meaning: '许多（可数）',
    usageScenario: '描述大量可数的事物，修饰可数名词复数',
    example: 'I have many books.',
    exampleTranslation: '我有许多书。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'quant_many_people',
    phrase: 'many people',
    phonetic: '/ˈmeni ˈpiːpl/',
    meaning: '许多人',
    usageScenario: '描述大量人群',
    example: 'There are many people in the park.',
    exampleTranslation: '公园里有许多人。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'quant_a_few',
    phrase: 'a few',
    phonetic: '/ə fjuː/',
    meaning: '几个（可数）',
    usageScenario: '描述少量可数的事物，表示有一些但不多',
    example: 'I have a few friends.',
    exampleTranslation: '我有几个朋友。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'quant_few',
    phrase: 'few...',
    phonetic: '/fjuː/',
    meaning: '很少（可数）',
    usageScenario: '描述很少可数的事物，强调数量不足',
    example: 'There are few apples left.',
    exampleTranslation: '剩下的苹果很少。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    frequency: 'low'
  },

  // 数量描述（不可数）
  {
    id: 'quant_much',
    phrase: 'much...',
    phonetic: '/mʌtʃ/',
    meaning: '许多（不可数）',
    usageScenario: '描述大量不可数的事物，修饰不可数名词',
    example: 'I drink much water.',
    exampleTranslation: '我喝很多水。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'quant_a_little',
    phrase: 'a little',
    phonetic: '/ə ˈlɪtl/',
    meaning: '一点（不可数）',
    usageScenario: '描述少量不可数的事物，表示有一些但不多',
    example: 'I have a little money.',
    exampleTranslation: '我有一点钱。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'quant_little',
    phrase: 'little...',
    phonetic: '/ˈlɪtl/',
    meaning: '很少（不可数）',
    usageScenario: '描述很少不可数的事物，强调数量不足',
    example: 'There is little water left.',
    exampleTranslation: '剩下的水很少。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    frequency: 'low'
  },

  // 大量表达
  {
    id: 'quant_a_lot_of',
    phrase: 'a lot of',
    phonetic: '/ə lɒt əv/',
    meaning: '许多、大量',
    usageScenario: '描述大量的事物，可用于可数和不可数名词',
    example: 'I have a lot of homework.',
    exampleTranslation: '我有许多作业。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'quant_lots_of',
    phrase: 'lots of',
    phonetic: '/lɒts əv/',
    meaning: '许多、大量',
    usageScenario: 'a lot of的口语形式，用于可数和不可数名词',
    example: 'There are lots of books in the library.',
    exampleTranslation: '图书馆里有许多书。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'quant_plenty_of',
    phrase: 'plenty of',
    phonetic: '/ˈplenti əv/',
    meaning: '充足的',
    usageScenario: '描述数量充足、足够',
    example: 'We have plenty of time.',
    exampleTranslation: '我们有充足的时间。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    frequency: 'medium'
  },

  // 一些和任何
  {
    id: 'quant_some',
    phrase: 'some...',
    phonetic: '/sʌm/',
    meaning: '一些',
    usageScenario: '描述不确定的数量，用于肯定句',
    example: 'I have some apples.',
    exampleTranslation: '我有一些苹果。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'quant_some_water',
    phrase: 'some water',
    phonetic: '/sʌm ˈwɔːtər/',
    meaning: '一些水',
    usageScenario: '描述不确定数量的水',
    example: 'Can I have some water?',
    exampleTranslation: '我可以要一些水吗？',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'quant_any',
    phrase: 'any...',
    phonetic: '/ˈeni/',
    meaning: '任何',
    usageScenario: '描述不确定的数量，用于疑问句和否定句',
    example: "Do you have any books?",
    exampleTranslation: '你有书吗？',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'quant_not_any',
    phrase: 'not any',
    phonetic: '/nɒt ˈeni/',
    meaning: '没有',
    usageScenario: '描述没有任何',
    example: "I don't have any money.",
    exampleTranslation: '我没有任何钱。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'quant_no',
    phrase: 'no...',
    phonetic: '/noʊ/',
    meaning: '没有',
    usageScenario: '描述完全没有',
    example: 'There is no water in the bottle.',
    exampleTranslation: '瓶子里没有水。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },

  // 所有
  {
    id: 'quant_all',
    phrase: 'all...',
    phonetic: '/ɔːl/',
    meaning: '所有的',
    usageScenario: '描述全部、所有',
    example: 'All the students are here.',
    exampleTranslation: '所有的学生都到了。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'quant_all_of',
    phrase: 'all of...',
    phonetic: '/ɔːl əv/',
    meaning: '所有的……',
    usageScenario: '描述某个群体的全部',
    example: 'All of us like pizza.',
    exampleTranslation: '我们所有人都喜欢披萨。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'quant_most',
    phrase: 'most...',
    phonetic: '/moʊst/',
    meaning: '大多数',
    usageScenario: '描述大部分、大多数',
    example: 'Most students like English.',
    exampleTranslation: '大多数学生喜欢英语。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    frequency: 'medium'
  },

  // 每一个
  {
    id: 'quant_each',
    phrase: 'each...',
    phonetic: '/iːtʃ/',
    meaning: '每一个',
    usageScenario: '描述群体中的每一个个体',
    example: 'Each student has a book.',
    exampleTranslation: '每个学生都有一本书。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'quant_every',
    phrase: 'every...',
    phonetic: '/ˈevri/',
    meaning: '每个',
    usageScenario: '描述群体中的所有个体',
    example: 'Every child likes toys.',
    exampleTranslation: '每个孩子都喜欢玩具。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },

  // 其他数量表达
  {
    id: 'quant_enough',
    phrase: 'enough...',
    phonetic: '/ɪˈnʌf/',
    meaning: '足够的',
    usageScenario: '描述数量充足、够用',
    example: 'We have enough food.',
    exampleTranslation: '我们有足够的食物。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'quant_more',
    phrase: 'more...',
    phonetic: '/mɔːr/',
    meaning: '更多的',
    usageScenario: '描述数量更多',
    example: 'I want more apples.',
    exampleTranslation: '我想要更多的苹果。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'quant_less',
    phrase: 'less...',
    phonetic: '/les/',
    meaning: '更少的',
    usageScenario: '描述数量更少（不可数）',
    example: 'I want less sugar.',
    exampleTranslation: '我想要更少的糖。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
];